import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import YouTube from 'react-youtube'
import { YoutubeVideoProps, PLAYER_VARS } from './types'
import useIsInArticleContent from '@hooks/useIsInArticleContent'
import useIsInScribbleContent from '@hooks/useIsInScribbleContent'
import { useVideo } from '@hooks/useVideo'
import useIsInRecipeContent from '@hooks/useIsInRecipeContent'
import { printCSS } from '@utils/style'

const opts = {
  playerVars: PLAYER_VARS,
}

const YoutubeVideoWrapper = styled.div<{
  shouldStretch: boolean
  shouldStretchToFitCard?: boolean
}>`
  ${({
    theme: {
      measures: { stretch, stretchToFitCard },
    },
    shouldStretch,
    shouldStretchToFitCard,
  }) => css`
    ${printCSS(css`
      display: none;
    `)}
    ${shouldStretch &&
    css`
      ${stretch('left')}
      ${stretch('right')}
    `}
    ${shouldStretchToFitCard &&
    css`
      ${stretchToFitCard('left')}
      ${stretchToFitCard('right')}
    `}
  `}
`

const StyledYoutubeMainElementContainer = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
`

const StyledYoutubeMainElement = styled(YouTube)`
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const YoutubeVideo: FunctionComponent<YoutubeVideoProps> = ({ videoId }) => {
  const isInArticle = useIsInArticleContent()
  const isInScribble = useIsInScribbleContent()
  const isInRecipe = useIsInRecipeContent()
  const { addVideo } = useVideo()

  const shouldStretch = isInArticle && !isInScribble && !isInRecipe

  if (!videoId) {
    return null
  }

  return (
    <YoutubeVideoWrapper
      shouldStretch={shouldStretch}
      shouldStretchToFitCard={isInRecipe}>
      <StyledYoutubeMainElementContainer>
        <StyledYoutubeMainElement
          videoId={videoId}
          opts={opts}
          onPlay={(e: { target: any }) => {
            addVideo({
              id: videoId || '',
              ref: e.target,
              type: 'youtube',
            })
          }}
        />
      </StyledYoutubeMainElementContainer>
    </YoutubeVideoWrapper>
  )
}

export default YoutubeVideo
